import React from 'react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from './ui/Accordion';
export function FAQSection() {
  const faqs = [{
    question: 'Do you offer free estimates?',
    answer: "Yes! We offer completely free estimates with no strings attached. Let's discuss your project today."
  }, {
    question: 'What types of outdoor lighting do you install?',
    answer: 'We install bistro lights, architectural lights, landscape lights, hardscape lights, sport court lights, security lights, and backyard lights.'
  }, {
    question: 'What areas do you serve?',
    answer: 'We serve the entire greater Phoenix area including Chandler, Gilbert, Queen Creek, Mesa, Phoenix, Paradise Valley, Scottsdale, Fountain Hills, San Tan Valley, and Tempe.'
  }, {
    question: 'How long does installation take?',
    answer: "Timelines vary by project size. Smaller jobs may take just a day, while larger projects can take a few days. We'll provide a detailed schedule after your consultation."
  }, {
    question: 'Do I need to be home during installation?',
    answer: "Not necessarily. As long as we have access to your property and a clear plan, we can complete the work. We'll keep you updated with photos and progress reports."
  }, {
    question: 'What makes Love Outdoor Lighting different?',
    answer: 'We take a design-driven approach built on transparency, integrity, and hard work. Every project is custom-designed for your specific property.'
  }];
  return <section className="w-full bg-[var(--brand-soft-white)] py-20 lg:py-28" data-id="element-27">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl" data-id="element-28">
        <div className="text-center mb-16" data-id="element-29">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[var(--brand-charcoal)] uppercase tracking-wider mb-4" data-id="element-30">
            Frequently Asked Questions
          </h2>
        </div>

        <Accordion type="single" collapsible className="w-full space-y-4" data-id="element-31">
          {faqs.map((faq, index) => <AccordionItem key={index} value={`item-${index}`} className="bg-white border border-gray-200 rounded-lg px-6 data-[state=open]:border-[var(--brand-gold)] data-[state=open]:ring-1 data-[state=open]:ring-[var(--brand-gold)] transition-all" data-id="element-32">
              <AccordionTrigger className="text-left text-lg font-semibold text-[var(--brand-charcoal)] hover:no-underline hover:text-[var(--brand-gold)] py-6" data-id="element-33">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-gray-600 text-base pb-6 leading-relaxed" data-id="element-34">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
      </div>
    </section>;
}